export const API_MOCK_URL = "http://localhost:9000";
// export const API_URL = "https://119.91.226.30:9000";
export const API_URL =
  "https://qianbot-115575-5-1317982725.sh.run.tcloudbase.com";
